export default {
    amount: $localize `Sum`,
    percent: $localize `Percent`,
}